import posthog from 'posthog-js'
import { getPartnersCache } from '@/utilities/partnersCache'
import { errorAnalyticsPayload } from './errorAnalytics'

export type PartnerGroupInfo = {
  partnerId: string
  partnerName: string
  canPlaceOrder: boolean
}

/**
 * Sets the PostHog `client` group to an Ash partner/program (not a Stytch org).
 */
export function identifyPartnerGroup(partner: PartnerGroupInfo): void {
  try {
    posthog.group('client', partner.partnerId, {
      name: partner.partnerName,
      can_place_order: partner.canPlaceOrder,
    })
  } catch (error) {
    console.error('PostHog partner group identification failed:', errorAnalyticsPayload(error))
  }
}

/**
 * Syncs PostHog's `client` group from the selected partner ID.
 * Uses partners cache for metadata when available; otherwise sets the group key only
 * so `$group_0` is correct for chart scoping.
 * Returns true when the group key was set.
 */
export function syncPostHogPartnerGroup(clientId: string): boolean {
  const partner = getPartnersCache()?.find((p) => p.partnerId === clientId)
  if (partner) {
    identifyPartnerGroup(partner)
    return true
  }

  try {
    posthog.group('client', clientId, {})
    return true
  } catch (error) {
    console.error('PostHog partner group identification failed:', errorAnalyticsPayload(error))
    return false
  }
}
